type Props = { text: string | undefined | React.ReactNode; className?: string };

export default function Heading({ text, className }: Props) {
  return <h2 className={`text-lg font-medium text-neutral-100 ${className}`}>{text ?? ""}</h2>;
}
